// require("../scss/index.scss");

require("./theme/bootstrap/bootstrap");
require("../library/bootstrapValidator/bootstrapValidator.min");
const background = require("./theme/components/background");
const formevents = require("./theme/components/formevents");
const forminputs = require("./theme/components/forminputs");
const navigation = require("./theme/components/navigation");
const captcha = require("./theme/components/captcha");

const $ = require('jquery');
global.$ = global.jQuery = $;

$(function () {
    background();
    formevents.init();
    forminputs.init();
    navigation.init();
    captcha.init();
});
